// extracted by mini-css-extract-plugin
export default {"productSize":"G2G4Z","sizeTitle":"IFqJY","sizeValue":"z4kTK","leavesden2":"UxrZ7","leavesden3":"gBCgD"};